import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import backbutton from './assets/backbutton.png';
import SEO from './components/SEO';
import './css/TermsOfService.css';

function TermsOfService() {
  return (
    <div className="terms-container">
      <SEO 
        title="Terms of Service - Savory"
        description="Read Savory's terms and conditions to understand your rights and responsibilities when using our recipe platform and services."
        keywords="terms of service, terms and conditions, Savory legal, user agreement, app terms"
        url="/terms"
        type="article"
      />
      
      <div className="back-button-container">
        <Link to="/" className="back-button-details">
          <img src={backbutton} alt="Back" className="backButtonImg" />
        </Link>
      </div>

      <motion.div 
        className="terms-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.header 
          className="terms-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h1>Terms and Conditions</h1>
          <p className="last-updated">Last updated: March 26, 2024</p>
        </motion.header>

        <motion.div 
          className="terms-sections"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <section className="terms-section">
            <p className="intro-text">
              By downloading or using the Savory app, you agree to these terms. Please read them carefully before using the app. You may not copy, modify, or reverse-engineer any part of the app or its content, nor may you attempt to extract the source code or create derivative works. All intellectual property rights, including trademarks, copyright, and database rights, remain the exclusive property of Savory.
            </p>
          </section>

          <section className="terms-section">
            <h2>Service Commitment</h2>
            <p>
              Savory is committed to delivering a reliable and helpful experience. We may make changes to the app or its services at any time. If we decide to charge for any features, we will clearly communicate what you're paying for before you are billed.
            </p>
          </section>

          <section className="terms-section">
            <h2>Personal Data and Device Security</h2>
            <p>
              The Savory app processes personal data that you provide in order to deliver its services. You are responsible for maintaining the security of your device and access to the app. We strongly recommend against jailbreaking or rooting your phone, as this may compromise your device's security and affect the app's performance or usability.
            </p>
          </section>

          <section className="terms-section">
            <h2>Internet Connection and Data Usage</h2>
            <p>
              Some features of Savory require an active internet connection. We are not responsible for limited functionality due to lack of Wi-Fi or mobile data. If you use the app outside of Wi-Fi coverage, your mobile provider may charge for data usage or roaming. By using the app, you accept responsibility for any associated charges. If you are not the bill payer for the device, we assume you have permission from the person who is.
            </p>
          </section>

          <section className="terms-section">
            <h2>Device Responsibility</h2>
            <p>
              You are also responsible for keeping your device charged and functioning. Savory is not liable if the service becomes unavailable due to a drained battery or hardware issue.
            </p>
          </section>

          <section className="terms-section">
            <h2>Third-Party Content and Liability</h2>
            <p>
              While we strive to keep Savory updated and functioning properly, the app may rely on external content or third-party data. We are not liable for any loss, direct or indirect, arising from your reliance on this content.
            </p>
          </section>

          <section className="terms-section">
            <h2>App Updates and Discontinuation</h2>
            <p>
              We may periodically update the app. You agree to accept updates to continue using the latest version. We may also discontinue the app or restrict access at any time, without prior notice. If that happens, you must stop using the app and, if necessary, uninstall it from your device.
            </p>
          </section>

          <section className="terms-section">
            <h2>Changes to These Terms and Conditions</h2>
            <p>
              We may update these Terms and Conditions from time to time. Please check this page periodically for any changes. We will post any updates here.
            </p>
          </section>

          <section className="terms-section contact-section">
            <h2>Contact Us</h2>
            <p>
              If you have questions about these Terms and Conditions, feel free to contact us at:
            </p>
            <p className="contact-email">
              📧 <a href="mailto:team@savory.ink">team@savory.ink</a>
            </p>
          </section>
        </motion.div>

        <motion.footer 
          className="terms-footer"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <p>By using Savory, you acknowledge that you have read and understood these terms.</p>
          <div className="footer-links">
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
            <Link to="/" className="back-to-home">
              ← Back to Savory
            </Link>
          </div>
        </motion.footer>
      </motion.div>
    </div>
  );
}

export default TermsOfService;